<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Профиль') }}</h1>
    <div class="private-pg">
      <form action="">
        <div class="profile-section" v-if="user && fields">
          <div class="profile-user-info">
            <div class="bgw-pdg-20">
              <ul>
                <li>
                  <span>{{ $t('ФИО') }}:</span>
                  <a
                    v-if="
                      (!user.first_name && !user.second_name &&
                       !user.last_name && !fields.name.showEdit)
                        "
                    @click="fields.name.showEdit = true"
                  >
                    {{ $t('add') }}
                  </a>
                  <a
                    v-else-if="!fields.name.showEdit"
                    @click="fields.name.showEdit = true"
                  >
                    {{ user.first_name }} {{ user.second_name }}
                    {{ user.last_name }}
                  </a>
                  <InlineEdit
                    v-else
                    :params="fields.name"
                    @update-field="updateField($event)"
                    class="edit-field"
                  />
                </li>
                <li>
                  <span>{{ $t('Электронный адрес') }}:</span>
                  {{ user.email }}
                </li>
                <li>
                  <span>{{ $t('Дата создания') }}:</span>
                  {{
                  new Date(user.created_date) | dateFormat('DD.MM.YYYY')
                  }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </form>
    </div>
  </v-container>
</template>

<script>
import User from '@/model/user'
import InlineEdit from '@/components/user/InlineEdit'
import { mapMutations } from 'vuex'

export default {
  components: {
    InlineEdit
  },
  data: () => ({
    user: [],
    breadcrumbs: [],
    baseUrl: process.env.VUE_APP_BACK_URL,
    fields: null
  }),
  created () {
    // загружаем данные, когда представление создано
    // и данные реактивно отслеживаются
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      User.getCurrentInfo()
        .then((response) => {
          this.user = response.data
          this.initFields()

          this.breadcrumbs = [
            {
              text: this.$i18n.t('Главная'),
              disabled: false,
              href: '/'
            },
            {
              text: this.$i18n.t('Рабочий кабинет'),
              disabled: false,
              href: '/my-organization'
            },
            {
              text: this.$i18n.t('Профиль'),
              disabled: true
            }
          ]
          this.setLoading(false)
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push({
              name: 'login'
            })
          }
          this.$router.push({
            name: 'error',
            params: {
              status: error.response.status
            }
          })
          this.setLoading(false)
        })
    },
    initFields () {
      this.fields = {
        name: {
          name: 'name',
          showEdit: false,
          fields: [
            {
              name: 'firstName',
              label: 'Фамилия',
              value: this.user.first_name,
              type: 'varchar'
            },
            {
              name: 'secondName',
              label: 'Имя',
              value: this.user.second_name,
              type: 'varchar'
            },
            {
              name: 'lastName',
              label: 'Отчество',
              value: this.user.last_name,
              type: 'varchar'
            }
          ]
        }
      }
    },
    updateField (result) {
      if (result.status) {
        if (result.user) {
          this.user = result.user
        }

        this.fields[result.fieldName].showEdit = false
      }
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>
